import {
  GET_DISTRICT_LIST_FAIL,
  GET_DISTRICT_LIST_REQUEST,
  GET_DISTRICT_LIST_SUCCESS,
} from "src/constants/types";
import { with_auth } from "src/adapter";
import adapter from "src/adapter/header";
import { errorSWAL } from "../components/SweetAlert";
import i18n from "src/i18n";

export const getDistrictList =
  ({ AreaId = "", Name = "" } = {}) =>
  async (dispatch) => {
    dispatch({ type: GET_DISTRICT_LIST_REQUEST });

    try {
      const result = await adapter({
        url: `/district`,
        method: "GET",
        headers: with_auth(),
        params: {
          AreaId,
          Name,
        },
      });

      dispatch({ type: GET_DISTRICT_LIST_SUCCESS, payload: result.Data.District });
    } catch (e) {
      dispatch({ type: GET_DISTRICT_LIST_FAIL, payload: e.data.Status });
      errorSWAL({
        text:
          e.data && e.data.Status && e.data.Status.Message
            ? e.data.Status.Message
            : i18n.t("swal.error"),
        confirmButtonText: i18n.t("utils.ok"),
      });
    }
  };
